import { Empty, PortalHeading } from "./PortalLayout";
import { JobTimeline } from "@/components/shared/JobTimeline";
import { JobDetails } from "@/components/shared/JobDetails";
import { useFetch } from "@/hooks/useFetch";

export default function Jobs() {
  const { data } = useFetch("/jobs/mine");
  return (
    <div data-testid="portal-jobs">
      <PortalHeading title="Live Job Tracking" sub="Customer-safe view of each stage your vehicle moves through." />
      {data && !data.jobs.length && <Empty testId="jobs-empty">No jobs on record yet.</Empty>}
      <div className="space-y-8">
        {data?.jobs.map((j) => (
          <section key={j.reference} className="space-y-4">
            <div className="rounded-2xl bg-white p-6"><JobTimeline job={j} /></div>
            <JobDetails job={j} />
          </section>
        ))}
      </div>
    </div>
  );
}
